import MLVisaCardImage from './MLVisaCardImage'

export default MLVisaCardImage
